import { Link } from 'react-router-dom'
import { Button, Container, Stack, Text, Title } from '@mantine/core'

/**
 * 403 amigável (M-07 / TASK-2831). Renderizado pelo RequirePermission quando o
 * usuário não tem a permissão da rota. NÃO redireciona — evita loop de
 * navegação e mantém a URL para deep-links/refresh. É defense-in-depth: o
 * backend continua a autoridade; esta tela só melhora a UX de acesso negado.
 */
export function Forbidden() {
  return (
    <Container size="sm" py="xl">
      <Stack align="center" gap="sm" mt="xl">
        <Title order={1} c="var(--ai-text-muted)" style={{ fontSize: 48 }}>
          403
        </Title>
        <Title order={3}>Acesso negado</Title>
        <Text c="var(--ai-text-muted)" ta="center">
          Você não tem permissão para acessar esta página. Se acredita que isto é
          um engano, fale com um administrador.
        </Text>
        <Button component={Link} to="/" mt="md" variant="light">
          Voltar para o início
        </Button>
      </Stack>
    </Container>
  )
}
